<template>
  <md-content>
    <div class="password-fields">
      <md-field :style="styles.passwordField">
        <label>{{ t('現在のパスワード') }}</label>
        <md-input v-model="state.currentPassword" type="password" />
      </md-field>

      <md-field md-has-password :style="styles.passwordField">
        <label>{{ t('新しいパスワード') }}</label>
        <md-input v-model="state.newPassword" type="password" />
      </md-field>

      <md-field md-has-password :style="styles.passwordField">
        <label>{{ t('パスワードの確認') }}</label>
        <md-input v-model="state.confirmNewPassword" type="password" />
      </md-field>
    </div>

    <div class="actions md-layout md-alignment-center-space-between">
      <button class="" @click="doChangePassword">{{ t('確定') }}</button>
      <button class="" @click="closeModal">{{ t('キャンセル') }}</button>
    </div>

    <div v-if="state.loading" class="loading-overlay">
      <md-progress-spinner md-mode="indeterminate" :md-stroke="2" />
    </div>
  </md-content>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, ref } from 'vue';
import { changePassword } from '@/awsCodes/awsUtils';
import { required, minLength } from '@vuelidate/validators';
import Logger from '@/utils/logger';
import { getValidateFunctions, setRule } from '@/utils/validate/validate';
import useVuelidate from '@vuelidate/core';
import { StateInterface } from '@/store';
import { useStore, Store } from 'vuex';
import { i18n } from '@/i18n';

export default defineComponent({
  setup(props, context) {
    const t = i18n.t;
    const store = ref<Store<StateInterface> | undefined>(); // storeをreactiveな変数で定義
    const state = reactive({
      currentPassword: '',
      newPassword: '',
      confirmNewPassword: '',
      loading: false,
    });
    onMounted(() => {
      store.value = useStore(); // mystoreの情報を取得するのを待ちたい
    });
    // }satisfies Record<string, any>); こうしたい...

    // TODO: validatorが動作していない。。。
    // --Validator setting: 必ずこの順番に記述すること
    const { errorOutput, sameAs, passwordPolicy, reValidate } = getValidateFunctions(state, 'newPassword');
    const rules = {
      currentPassword: { required },
      newPassword: { required, minLength: minLength(8), passwordPolicy },
      confirmNewPassword: { sameAsPassword: sameAs },
    };
    const v$ = useVuelidate(rules, state, { $lazy: true });
    setRule(rules);
    // ---- end of validator setting
    const doChangePassword = async () => {
      if (!store.value) {
        // storeのundefinedチェック
        console.error('Store is not initialized yet');
        return;
      }

      v$.value.currentPassword.$touch();
      console.log(v$.value.$errors.length);
      if (v$.value.$anyDirty && v$.value.$errors.length > 0) {
        console.log('入力エラーがあります。修正をお願いします');
        return;
      }
      // TODO: validation
      const username = store.value.getters['loginStateModule/email'];

      const ret = await changePassword(username, state.currentPassword, state.newPassword);
      if (ret.success) {
        alert('パスワードを変更しました');
        context.emit('cancel', false);
      } else {
        Logger.error(ret.message);
        alert('パスワード変更に失敗しました');
        context.emit('cancel', false);
      }
    };

    const closeModal = () => {
      context.emit('cancel', false);
    };

    const styles = {
      passwordField: {
        marginBottom: '20px',
      },
    };

    return {
      state,
      v$,
      errorOutput,
      reValidate,
      doChangePassword,
      closeModal,
      styles,
      t,
    };
  },
});
</script>

<style lang="scss" scoped>
.card-bg {
  background-color: #162b4d;
}
.password-fields {
  input {
    height: 25px;
    margin-top: 20px;
  }
  label {
    font-size: 14px !important;
  }
}
</style>
